<template>
  <div>
    <el-menu
      :default-active="routerNameActive"
      class="menu-aps"
      background-color="#232323"
      text-color="#fff"
      router
    >
      <template v-for="item in menuLists">
        <el-submenu
          :index="item.meta.title"
          v-if="item.children && item.children.length > 0"
          :key="item.meta.title"
        >
          <template slot="title">
            <img :src="item.meta.icon" />
            <span>{{ item.meta.title }}</span>
          </template>
          <el-menu-item  @click="menuHandle(w)"
            v-for="w in item.children"
            :index="w.path"
            :key="w.meta.title"
            >{{ w.meta.title }}</el-menu-item
          >
        </el-submenu>
        <el-menu-item v-else :index="item.path" :key="item.index" @click="menuHandle(item)">
          <img :src="item.meta.icon" />
          <span slot="title">{{ item.meta.title }}</span>
        </el-menu-item>
      </template>
      
    </el-menu>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
export default {
  name: "SideLeft",
  data() {
    return {
      routerNameActive: '0'
    };
  },
  computed: {
    ...mapState(['menuLists','menuCur'])
  },
  watch: {
    '$route': {
      handler() {
          this.setCurRoute();
        },
    },
  },
  mounted(){
    this.setCurRoute();
  },
  methods: {
  ...mapMutations(['SET_MENUCUR']),
    menuHandle(data) {
      this.SET_MENUCUR(data.path)
    },
    setCurRoute() {
      this.routerNameActive = this.$route.path;
    }
  }
};
</script>

<style lang="scss" scoped>
.menu-aps {
  color: #fff;
  font-size: 18px !important;
  background: #232323;
  text-align: left;
  height: 94vh;
}
.menu-aps a {
  color: #fff;
}
.menu-aps img {
  width: 28px;
  height: 28px;
  margin-right: 8px;
}
::v-deep.el-menu {
  background-color: transparent;
  border-right: none;

  .el-menu-item {
    color: #221e1e;
    height: 50px;
    line-height: 50px;
    font-size: 18px !important;
    margin: 10px 0;
    color: #B9B9B9 !important;
    i {
      color: #B9B9B9;
    }
    img{
      width: 28px;
      height: 28px;
    }
  }
  .el-menu-item:hover{
    background-color: transparent;
    background-position: center;
    border-right: 2px solid #2deb79;
    background: linear-gradient(
      270deg,
      rgba(0, 255, 112, 0.55) 0%,
      rgba(94, 223, 150, 0.14) 100%
    ) !important;
  }
  .el-menu-item.is-active {
    color: #ffffff;
    border-right: 2px solid #2deb79;
    background: linear-gradient(
      270deg,
      rgba(0, 255, 112, 0.55) 0%,
      rgba(0, 255, 112, 0.14) 100%
    ) !important;
  }
  .el-submenu__title {
    margin-left: -4px;
    color: #B9B9B9 !important;
  }
  .el-submenu__title i {
    // color: #ffffff;
    color: #B9B9B9;
  }
  .el-menu-item-group {
    .el-menu-item-group__title {
      color: #ffffff;
    }
  }
  .el-submenu {
    .el-submenu__title {
      text-indent: 6px;
      font-size: 18px;
      height: 50px;
      line-height: 50px;
      color: #B9B9B9 !important;
      &:hover {
        background-color: transparent;
        background-position: center;
        border-right: 2px solid #2deb79;
        background: linear-gradient(
          270deg,
          rgba(0, 255, 112, 0.55) 0%,
          rgba(0, 255, 112, 0.14) 100%
        ) !important;
      }
    }
    .el-menu-item {
      min-width: 180px;
      text-indent: 14px;
    }
  }
}
</style>
